import React from 'react'
import { Line } from 'react-chartjs-2';
import { defaults } from 'react-chartjs-2';
import moment from 'moment';
import { apiService } from '../../common/apiCallService'
import { baseUrl } from '../../common/config.js';
import Loading from '../Loading.js';

import './tournament-watch.css'


defaults.global.elements.point.pointStyle = 'circle';
defaults.global.elements.point.radius = 3;
defaults.global.elements.point.hoverRadius = 10;

/**
 * :: Props ::
 * > onClose : function
 * > tournament : object
 * > tournamentType : object
 */
class OverlayChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tournament : {},
            tournamentHistory : [],
            chartData : {
                labels : [],
                datasets : []
            },
            loading : true
        }
        
    }

    getMinsToStartDisplay = (time) => {
        const duration = moment.duration(Math.abs(time))
        let timeString = `${duration.hours()}:${duration.minutes()}`
        if (time < 0) return `-${timeString}`;
        else return timeString;
    }

    componentDidMount() {
        this.setUpChart();
    }

    setUpChart = () => {
        const {tournamentId} = this.props;
        Promise.all([
            this.props.getTournament(tournamentId),
            this.getTournamentHistory(tournamentId)
        ])
        .then(data => {
            const [
                tournament, 
                tournamentHistory 
            ] = data;
            // console.log(':::::::::::::::::');
            // console.log(tournamentHistory);
            
            const {
                StartDate, 
                minsToReg,
                appliedTournamentType,
            } = tournament;
            
            const timeline = this.getTimeline(moment(StartDate), appliedTournamentType.stageParams.length, minsToReg);
            const datasets = this.getDatasets(tournament, appliedTournamentType, timeline, tournamentHistory);

            this.setState({
                chartData : {
                    labels : timeline.map(time => time.format('HH:mm')),
                    datasets
                },
                tournament,
                tournamentHistory,
                loading : false
            })
        })
    }

    getTournamentHistory = tournamentID => new Promise((resolve, reject) => {
        // console.log(`gettting history of tournaments for tournamentId [${tournamentID}]`);
        apiService(
            baseUrl + '/mtt/tournamenthistory',
            {tournamentId : tournamentID},
            resolve,
            reject
        )
    })

    getTimeline = ( StartDate, noOfPoints, lateRegMins ) => {
        let totalTime = moment().diff(StartDate) + lateRegMins;
        if(totalTime < 0 ) 
            return []

        const increment = totalTime / (noOfPoints - 1);

        let pointer = 0;
        let cordinates = [];
        cordinates.push(0);
        
        while ( Math.round(pointer) < Math.round(totalTime - increment) ) {
            pointer = pointer + increment;
            cordinates.push(pointer);
        }
        cordinates.push(totalTime);
        let timeline = cordinates.map(cor => {
            return moment(StartDate).add(cor/(60*1000), 'minutes');            
        })
        return timeline;
    }

    getDatasets = (tournament, tournamaentType, timeline, tournamentHistory) => {
        if(timeline.length == 0) return [];
        
        let linearCurve, expectedCurve, actualCurve, predictedCurve;
        const {minimumRegCount} = tournament;
        let firstPoint = (minimumRegCount * tournamaentType.stageParams[0].expectedPercent) / 100;

        linearCurve = this.getLinearCurve( firstPoint, minimumRegCount, tournamaentType.stageParams.length );
        expectedCurve = this.getExpectedCurve(tournamaentType.stageParams.map(param => param.expectedPercent), minimumRegCount);
        actualCurve = this.getActualCurve(timeline, tournamentHistory);
        predictedCurve = this.getPredictedCurve(expectedCurve, actualCurve);

        return [linearCurve, expectedCurve, actualCurve, predictedCurve];
    }

    getLinearCurve = (startPoint, endPoint, noOfPoints) => {
        let cordinates = [];
        const pointsToCover = endPoint - startPoint;
        const increment = pointsToCover / (noOfPoints - 1);
        
        cordinates.push(startPoint);
        let pointer = startPoint;
        while (Math.round(pointer) < Math.round(endPoint - increment)) {
            pointer = pointer + increment;
            cordinates.push(pointer);
        }
        cordinates.push(endPoint);

        return {
            label: 'Linear Prediction',
            data: cordinates,
            borderColor: '#3CD98A'
        };
    }

    getExpectedCurve = (steps, endPoint) => {
        // console.log(steps.map(step => {
        //     console.log('>>>>>>>>>>>>');
        //     console.log(step);
        //     console.log((endPoint * step) / 100)
        // }));
        
        return {
            label: 'Expected Curve',
            data: steps.map(step => (endPoint * step) / 100),
            borderColor: '#2DC1CB',
            backgroundColor : 'transparent'
        }
    }
    
    getActualCurve = (timeline, tournamentHistory) => {
        let cordinates = [];
        // console.log(`tournamentHistory[length] : ${tournamentHistory.length}`);
        
        if(tournamentHistory.length != 0) {
            let lastTimeLineValue = null;
            for(let time of timeline) {
                if(time.diff(moment.utc()) > 0) {
                    if(lastTimeLineValue.diff(moment( tournamentHistory[tournamentHistory.length-1].Timestamp )) < 0) cordinates.push(this.getRegCountForTime(tournamentHistory, time).RegPlayersCount)
                    break;
                }
                lastTimeLineValue = time;
                cordinates.push(this.getRegCountForTime(tournamentHistory, time).RegPlayersCount)
            }
        }
        // console.log('Actual Cordinates');
        // console.log(cordinates);
        return {
            label: 'Actual Curve',
            data: cordinates,
            borderColor: '#b2a925',
        }
    }

    getRegCountForTime = (regData, time) => {
        let temp;
        for(let reg of regData) {
            if( time.diff( moment(reg.Timestamp) ) < 0 ) break;
            temp = reg;
        }
        return temp ? temp : { RegPlayersCount : 0 };
    }

    getPredictedCurve = ( expectedCurve, actualCurve ) => {
        if(actualCurve.data.length == 0) return [];
        let predictPercent = ( actualCurve.data[ actualCurve.data.length - 1 ] / expectedCurve.data[actualCurve.data.length - 1]) * 100;
        // console.log('predictPercent : ' + predictPercent );
        // console.log(`( ${actualCurve.data[ actualCurve.data.length - 1 ]} / ${expectedCurve.data[actualCurve.data.length - 1]}) * 100;`);
        let cordinates = expectedCurve.data.slice(actualCurve.data.length - 1).map(point => {
            return (point * predictPercent) / 100
        })

        return {
            label: 'Prediction Curve',
            data: [...Array(actualCurve.data.length - 1).fill(null),...cordinates],
            borderColor: 'red'
        }
    }

    TournamentDetailsHeader = _ => (
        <div className="tournament-details-header">
            <div id="th-name">Name</div>
            <div>Mins to Reg</div>
            <div>Buy In</div>
            <div>Mins to Start</div>
            <div>Overlay Percent</div>
            <div>Predicted Overlay</div>
            <div>Prize Pool</div>
            <div>Reg Players Count</div>
            <div></div>
        </div>
    )
    render() {
        const { chartData, tournament, loading } = this.state;
        return (
            <div>
                {loading ? 
                    <Loading/> :
                    <div data-e2e='tournamentDetailsGraph'>
                        <div className='tournament-details'>
                            <this.TournamentDetailsHeader/>                
                            <div id='display-info' style={{backgroundColor : tournament.flag.color}} className="table-row">
                                <div id="td-name">
                                    <span className="tr-title">
                                        <strong>
                                            Name : 
                                        </strong>
                                    </span>
                                    {tournament.Name}
                                </div>
                                <div className='data'> { this.getMinsToStartDisplay(tournament.minsToReg) }</div>
                                <div className='data'> { tournament.BuyIn } </div>
                                <div className='data'> { this.getMinsToStartDisplay(tournament.minsToStart) } </div>
                                <div className='data'> { tournament.OverlayPercent.toFixed(2) } </div>
                                <div className='data'> { tournament.PredictedOverlay.toFixed(2) } </div>
                                <div className='data'> { tournament.PrizePool } </div>
                                <div>
                                    <span className="tr-title">
                                        <strong>
                                            Reg Players Count :
                                        </strong>
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => this.props.openEditReg(tournament)}
                                        className="btn"
                                        style={{
                                            background: "rgba(24, 24, 25, 0.2)",
                                            margin: '0% 2%',
                                            width: "60%"
                                        }}
                                        >
                                        {tournament.RegPlayersCount}
                                    </button>
                                </div>
                                <div>
                                    <span className="tr-title">
                                        &nbsp;
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => this.props.close()}
                                        className="btn"
                                        style={{
                                            background: "#1F1F23",
                                            margin: '0% 2%',
                                            color : 'white',
                                            width: "75%"
                                        }}
                                        data-e2e="overlayChartCloseButton"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                        {chartData.labels.length == 0 ?
                            <centre><h3 style={{textAlign : 'centre', color : 'White'}}> Tournament haven't Started yet </h3></centre> :
                            <div>
                                <span id='potrait-message'>
                                    <centre><h2 style={{color : 'white'}}>Rotate to watch graph</h2></centre>
                                </span>
                                <div id='line-chart' style={{backgroundColor : '#e8efec', width : '100%'}}>
                                    <h3 className='col-3'style={{padding : '1%', display : 'inline'}}>{`${tournament.PredictedOverlayRegistration} Overlay People`}</h3>
                                    <button
                                        type="button"
                                        onClick={this.setUpChart}
                                        className="btn col-1"
                                    >
                                        Refresh
                                    </button>
                                    <Line
                                        height = {100}
                                        data={ chartData }
                                        />  
                                </div>  
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default OverlayChart;


/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/overlayChart.js
 **/